import axios from 'axios';
import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { FETCHING_ERROR,  FETCHING_START, FETCHING_SUCCESS_ADMIN, FETCHING_SUCCESS_ARES, FETCHING_SUCCESS_COLLECTOR, FETCHING_SUCCESS_COLLECTOR_PAYMENTS, FETCHING_SUCCESS_CUSTOMER, FETCHING_SUCCESS_CUSTOMER_PAYMENTS, FETCHING_SUCCESS_USER } from '../state/actionTypes/actionTypes';
import { globalReducer, initialState } from '../state/reducer/globalReducer';



export const GStore = createContext()

const Context = ({children}) => {
    
    const [english, setEnglish] = useState(false);

    const [state,dispatch] = useReducer(globalReducer,initialState);

    // user 
    useEffect(()=>{
        dispatch({type : FETCHING_START})
        const loginAccess = localStorage.getItem("loginAccess");
        axios.get(`https://amar-dish-server.vercel.app/user/observer?loginAccess=${loginAccess}`).then(res=>{
            // console.log(res.data);
            if(res.data.message === "success"){
                dispatch({type : FETCHING_SUCCESS_USER , payload : res.data.user})
                 
    if(res?.data?.user?.role === 'admin'){
        dispatch({type: FETCHING_SUCCESS_ADMIN , payload : res?.data?.user?.userNumber})
    }
    if(res?.data?.user?.role === "collector"){
        dispatch({type: FETCHING_SUCCESS_ADMIN , payload : res?.data?.user?.adminNumber})
    }
            }
        }).catch(error =>{
            console.log(error);
        }) 
    },[state.user.loginAccess])

    // set admin Number 
   
  
    // Areas get Fetching 

    useEffect(()=>{
        if(!state.user){
            return ;
        }
        dispatch({type : FETCHING_START})
        fetch(`https://amar-dish-server.vercel.app/areas?adminNumber=${state.adminNumber}}`)
        .then(res => res.json()).then(data=>{
            dispatch({type : FETCHING_SUCCESS_ARES , payload : data})
         }).catch(err => {
            dispatch({type : FETCHING_ERROR})
         }); 
    },[state?.adminNumber,!state.user])


    // Collectors get Fetching 
    // console.log(state?.user?.userNumber)
    
    useEffect(()=>{
        if(!state?.user){
            return ;
        }
        dispatch({type : FETCHING_START})
        fetch(`https://amar-dish-server.vercel.app/collector?number=${state?.user?.userNumber}`)
        .then(res => res.json()).then(data=>{
            // console.log(data);
            if(data.message === "not found"){
                return ;
            }
            dispatch({type : FETCHING_SUCCESS_COLLECTOR , payload : data})
         }).catch(err => {
            dispatch({type : FETCHING_ERROR})
         }); 
    },[state?.user?.userNumber,!state?.user])

    // Customers get Fetching 
    useEffect(()=>{
        if(!state.user){
            return ;
        }
        dispatch({type : FETCHING_START})
        fetch(`https://amar-dish-server.vercel.app/customer?adminNumber=${state?.adminNumber}`)
        .then(res => res.json()).then(data=>{
            dispatch({type : FETCHING_SUCCESS_CUSTOMER , payload : data})
         }).catch(err => {
            dispatch({type : FETCHING_ERROR})
         }); 
    },[state?.adminNumber,!state.user])

    // Customers payments and Collector payments get Fetching 
    useEffect(()=>{
        if(!state.user){
            return ;
        }
        dispatch({type : FETCHING_START})
        fetch(`https://amar-dish-server.vercel.app/customers/payments?adminNumber=${state?.adminNumber}`)
        .then(res => res.json()).then(data=>{
            dispatch({type : FETCHING_SUCCESS_CUSTOMER_PAYMENTS , payload : data})
            const payments = data.filter(payment =>payment?.collectorNumber === state?.user?.userNumber)
             dispatch({type : FETCHING_SUCCESS_COLLECTOR_PAYMENTS , payload : payments})
            // console.log(data,payments)
         }).catch(err => {
            dispatch({type : FETCHING_ERROR})
         }); 
    },[state?.adminNumber,!state.user])
    

    const customersAmountSum = state.customers.reduce((a,b)=> a + parseInt(b.monthlyFee),0)
    const stupidityAmountSum = state.customers.reduce((a,b)=> a + parseInt(b.stupidity),0)
    const payAmountAmountSum = state.payments.reduce((a,b)=> a + parseInt(b.payAmount),0)


    const information ={
        english,
        setEnglish,
        state,
        dispatch,
        customersAmountSum,
        stupidityAmountSum,
        payAmountAmountSum
    }
// console.log(state)
    return (
        <div>
            <GStore.Provider value={information}>
                {children}
            </GStore.Provider>
        </div>
    );
};

export const useGStore = ()=>{
    const context = useContext(GStore);
    return context;
}

export default Context;